import React from 'react';
import PropTypes from 'prop-types';
import { LinkWrapper } from '../atbat.style';

const AtBatLink = ({
    atbatindex,
    content,
    handlers
}) => {
    return (
        <LinkWrapper data-atbatindex={atbatindex} {...handlers}>{content}</LinkWrapper>
    );
};

AtBatLink.propTypes = {
    atbatindex: PropTypes.number
};

export default AtBatLink;